import { WebfontLoaderPlugin } from "pixi-webfont-loader";
import { Loader } from "pixi.js";
import '@pixi/graphics-extras';
Loader.registerPlugin(WebfontLoaderPlugin);